import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import { IntegrationsShell } from './IntegrationsShell';

const NotificationCenter = lazy(() => import('./screens/NotificationCenter').then((m) => ({ default: m.NotificationCenter })));
const RoutingStudio = lazy(() => import('./screens/RoutingStudio').then((m) => ({ default: m.RoutingStudio })));
const ResourceGroups = lazy(() => import('./screens/ResourceGroups').then((m) => ({ default: m.ResourceGroups })));
const ResourceGroupDetailPage = lazy(() => import('./screens/ResourceGroupDetailPage').then((m) => ({ default: m.ResourceGroupDetailPage })));
const DestinationMatrix = lazy(() => import('./screens/DestinationMatrix').then((m) => ({ default: m.DestinationMatrix })));
const CommunicationHub = lazy(() => import('./screens/CommunicationHub').then((m) => ({ default: m.CommunicationHub })));
const TicketingHub = lazy(() => import('./screens/TicketingHub').then((m) => ({ default: m.TicketingHub })));
const IntegrationAIAssistant = lazy(() => import('./screens/IntegrationAIAssistant').then((m) => ({ default: m.IntegrationAIAssistant })));
const IntegrationWarRoom = lazy(() => import('./screens/IntegrationWarRoom').then((m) => ({ default: m.IntegrationWarRoom })));
const TestingCenter = lazy(() => import('./screens/TestingCenter').then((m) => ({ default: m.TestingCenter })));
const SlackOverview = lazy(() => import('./screens/SlackOverview').then((m) => ({ default: m.SlackOverview })));
const MessageTemplates = lazy(() => import('./screens/MessageTemplates').then((m) => ({ default: m.MessageTemplates })));
const HelpCenter = lazy(() => import('./screens/HelpCenter').then((m) => ({ default: m.HelpCenter })));
const SlackWorkspaces = lazy(() => import('./screens/SlackWorkspaces').then((m) => ({ default: m.SlackWorkspaces })));
const SlackChannels = lazy(() => import('./screens/SlackChannels').then((m) => ({ default: m.SlackChannels })));
const DestinationDetail = lazy(() => import('./screens/DestinationDetail').then((m) => ({ default: m.DestinationDetail })));
const WorkspaceScreen = lazy(() => import('./screens/SlackScreens').then((m) => ({ default: m.WorkspaceScreen })));
const RoutingScreen = lazy(() => import('./screens/SlackScreens').then((m) => ({ default: m.RoutingScreen })));
const PreviewScreen = lazy(() => import('./screens/SlackScreens').then((m) => ({ default: m.PreviewScreen })));
const LogsScreen = lazy(() => import('./screens/SlackScreens').then((m) => ({ default: m.LogsScreen })));
const AnalyticsScreen = lazy(() => import('./screens/SlackScreens').then((m) => ({ default: m.AnalyticsScreen })));

export const integrationsModuleRoutes: RouteObject[] = [
  {
    path: 'system/notification-center',
    Component: IntegrationsShell,
    children: [
      { index: true, Component: NotificationCenter },
      { path: 'routing-studio', Component: RoutingStudio },
      { path: 'resource-groups', Component: ResourceGroups },
      { path: 'resource-groups/:groupId', Component: ResourceGroupDetailPage },
      { path: 'destination-matrix', Component: DestinationMatrix },
      { path: 'communication-hub', Component: CommunicationHub },
      { path: 'ticketing-hub', Component: TicketingHub },
      { path: 'ai-assistant', Component: IntegrationAIAssistant },
      { path: 'war-room', Component: IntegrationWarRoom },
      { path: 'testing', Component: TestingCenter },
    ],
  },
  {
    path: 'system/integrations/slack',
    Component: IntegrationsShell,
    children: [
      { path: 'overview', Component: SlackOverview },
      { path: 'workspaces', Component: SlackWorkspaces },
      { path: 'channels', Component: SlackChannels },
      { path: 'channels/:channelId', Component: DestinationDetail },
      { path: 'resource-groups', Component: ResourceGroups },
      { path: 'resource-groups/:groupId', Component: ResourceGroupDetailPage },
      { path: 'routing-studio', Component: RoutingStudio },
      { path: 'alert-rules', Component: RoutingScreen },
      { path: 'templates', Component: MessageTemplates },
      { path: 'logs', Component: LogsScreen },
      { path: 'analytics', Component: AnalyticsScreen },
      { path: 'testing', Component: TestingCenter },
      { path: 'help', Component: HelpCenter },
      { path: 'workspace', Component: WorkspaceScreen },
      { path: 'routing', Component: RoutingScreen },
      { path: 'preview', Component: PreviewScreen },
    ],
  },
];
